import React from 'react'
import { arrayOf, shape, string } from 'prop-types'
import IcoCheck from '../icons/IcoCheck'
import { ToastsRoot, ToastItem, ToastIcon, ToastMsg } from './styles'

export default function Toasts( { items } ) {
  return (
    <ToastsRoot>
      { items.map( ( toast ) => (
        <ToastItem key={ toast.id }>
          <ToastIcon>
            <IcoCheck
              height="15"
              style={{ 'color': '#fff' }}
              width="15"
            />
          </ToastIcon>
          <ToastMsg>{ toast.msg }</ToastMsg>
        </ToastItem>
      ) ) }
    </ToastsRoot>
  )
}

Toasts.propTypes = {
  'items': arrayOf( shape( {
    'id': string.isRequired,
    'msg': string.isRequired
  } ) ).isRequired
}
